import axiosInstance from "./axiosInstance";

export interface Chat {
  id: number;              
  external_id: string;    
  title: string | null;
  created_at: string;
  messages?: any[];
  db_id: string;          // Database ID associated with the chat      
}

// Get chat list (titles only, no messages) - using lightweight endpoint
export const getChatsForUser = async (userId: number) => {
  const { data } = await axiosInstance.get<Chat[]>(`/chats/list/${userId}`);
  return data;
};

// Get full chat details with all messages
export const getChatDetails = async (chatId: number) => {
  const { data } = await axiosInstance.get<Chat>(`/chats/details/${chatId}`);
  return data;
};

export const createChat = async (
  externalId: string,
  userId: number,
  dbId: string, 
  dbName?: string 
) => {
  const { data } = await axiosInstance.post<Chat>("/chats", {
    external_id: externalId,
    user_id:    userId,
    db_id: dbName ?? dbId,
    ...(dbName ? { database_name: dbName, title: dbName } : {})
  });
  return data;
};
export async function deleteChat(chatId: number): Promise<void> {
  await axiosInstance.delete(`/chats/${chatId}`);
}

export async function renameChat(chatId: number, title: string) {
  const { data } = await axiosInstance.post(`/chats/${chatId}/update-title`, { title });
  return data;
}